<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 25%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
  margin-bottom: 0px;
}
input, select {
  padding-top: 3px;
  padding-bottom: 3px;
  width: auto;
}
.fixHeightScrollable {
  overflow: auto;
  min-height: 200px;
  max-height: 500px;
}
/* .dx-state-readonly input {
    background-color: lightgray;
    color: blue;
} */
hr {
  border: none;
  height: 0.5px;
  /* Set the hr color */
  color: #ccc; /* old IE */
  background-color: #ccc; /* Modern Browsers */
}
.w33 {
  width: 33%;
}
table {
  width: 100%;
}
.collapsed > .hide-content,
.not-collapsed > .show-content {
    display: none;
}
.row-collapse {
  visibility: collapse;
}
label {
  width: 100%;
  padding-bottom: 0px;
  margin-bottom: 0px;
  float: none;
}
.full-width {
	float: none;
  width: 100% !important;
}
</style>
<template>
    <div>
      <b-form :validated="true" @submit="onSubmit" @reset="onReset">
        <div class="d-flex justify-content-between">
          <h4>General</h4>
          <div>
            <DxButton
              icon="save"
              hint="Save General report"
              :height="40"
              :use-submit-behavior="true"
              :disabled="!editable" />
              <!-- @click="onSubmit" / -->
            <DxButton
              icon="download"
              hint="Download General excel file"
              :height="40"
              />
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshForm" />
          </div>
          <!-- div>
            <b-button-group v-if="editableOps">
              <b-button type="submit" variant="outline-primary" size="sm"
                >Save</b-button
              >
              <b-button type="reset" variant="outline-danger" size="sm"
                >Reset</b-button
              >
            </b-button-group>
          </div -->
        </div>
        <br />
        <div>
          <table>
            <tr>
              <td class="d-flex pt-3 pb-1" @click="picData.collapsed = !picData.collapsed">
                <h5 align="left"> 
                <span>
                  <b-icon v-show="!picData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="picData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Personnel In Charge 
              </h5>
              </td>
            </tr>
            <tr :class="{ 'row-collapse': picData.collapsed }">
              <td class="d-flex justify-content-between">
                <b-row>
                  <b-col cols="4" class="pb-1">
                    <div class="dx-field">
                      <label for="input-supervisors" class="dx-field-label">Supervisors</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.supervisors" name="input-supervisors" :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4" class="pb-1">
                    <div class="dx-field">
                      <label for="input-superintendent" class="dx-field-label">Superintendent</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.superintendent" name="input-superintendent" :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4" class="pb-1">
                    <div class="dx-field">
                      <label for="input-tool-pusher" class="dx-field-label">Tool Pusher</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.toolPusher" name="input-tool-pusher" :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4" class="pb-1">
                    <div class="dx-field">
                      <label for="input-hse-supervisor" class="dx-field-label">HSE Supervisor</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.hseSupervisor" name="input-hse-supervisor" :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4" class="pb-1">
                    <div class="dx-field">
                      <label for="input-logistic-supervisor" class="dx-field-label">Logistic Supervisor</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.logisticSupervisor" name="input-logistic-supervisor" :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4" class="pb-1">
                    <div class="dx-field">
                      <label for="input-custom-role" class="dx-field-label">Custom Role</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.customRoles" name="input-custom-role" :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </td>
            </tr>
            <tr>
              <td class="d-flex pt-3 pb-1" @click="dcpData.collapsed = !dcpData.collapsed">
                <h5 align="left"> 
                <span>
                  <b-icon v-show="!dcpData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="dcpData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Drilling and Cost Progress
              </h5>
              <span>
                <!-- b-icon v-show="dcpData.mandatory" icon="check-circle" variant="success" / -->
                <b-icon v-show="!dcpData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
              </td>
            </tr>
            <tr :class="{ 'row-collapse': dcpData.collapsed }">
              <td class="d-flex justify-content-between">
                <b-row>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-previousDayMd" class="dx-field-label">Previous Day MD</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="previousDayMd" 
                          name="input-previousDayMd"
                          format="0.0"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-mdAt24" class="dx-field-label">MD at 24:00</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="mdAt24" 
                          name="input-mdAt24"
                          format="0.0"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-estTvd" class="dx-field-label">Estimated TVD at 24:00</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.estTvd" 
                          name="input-estTvd"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-24Hr" class="dx-field-label">24 Hour Progress</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="progress24h" 
                          name="input-24Hr"
                          format="0.0"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-section" class="dx-field-label">Section</label>
                      <div class="dx-field-value full-width">
                        <DxSelectBox 
                          v-model="form.phaseCode"
                          display-expr="text"
                          value-expr="value"
                          :items="comboOptionPhasecode" 
                          :input-attr="{ 'aria-label' : 'Phase Code' }" 
                          :show-clear-button="false"
                          :disabled="!editable" />  
                        <!-- DxTextBox
                          v-model="section" 
                          name="input-section"
                          :read-only="true"
                        / -->
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-24HrOBH" class="dx-field-label">24Hr On-Bottom Hours</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.obHours" 
                          name="input-24HrOBH"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-percent-completed" class="dx-field-label">Percent Activity Completed</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.percentActivityCompleted" 
                          name="input-percent-completed"
                          :disabled="!editable"
                          @change="dcpMandatoryCheck"
                        >
                          <DxValidator>
                            <DxRequiredRule :message="requiredMessage"/>
                          </DxValidator>
                        </DxNumberBox>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-budget-plan" class="dx-field-label">Budget Plan</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="budgetPlan" 
                          name="input-budget-plan"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-master/cost" class="dx-field-label">Daily Field Cost</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="dailyFieldCost" 
                          name="input-master/cost"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-cumulative-cost" class="dx-field-label">Cumulative Cost</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="cumulativeCost" 
                          name="input-cumulative-cost"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-remaining-budget" class="dx-field-label">Remaining Budget</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="remainingBudget" 
                          name="input-remaining-budget"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-days-from-spud" class="dx-field-label">Days From Spud</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="dayFromSpud" 
                          name="input-days-from-spud"
                          format="0.0"
                          :read-only="true"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-days-on-location" class="dx-field-label">Days On Location</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.dayOnLocation" 
                          name="input-days-on-location"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-ft" class="dx-field-label">Formation Type</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.formationType" 
                          name="input-ft"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-lcs" class="dx-field-label">Last Casing Size</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.lastCasingSize" 
                          name="input-lcs"
                          :disabled="!editable"
                        />
                        <!-- DxSelectBox 
                          :items="diameterOptions" 
                          :input-attr="{ 'aria-label' : 'Last Casing Size' }" 
                          :show-clear-button="true" / -->
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-lcd" class="dx-field-label">Last Casing Depth</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.lastCasingDepth" 
                          name="input-lcd"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-ncs" class="dx-field-label">Next Casing Size</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.nextCasingSize" 
                          name="input-ncs"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-ncd" class="dx-field-label">Next Casing Depth</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.nextCasingDepth" 
                          name="input-ncd"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </td>
            </tr>
            <tr>
              <td class="d-flex pt-3 pb-1" @click="dpData.collapsed = !dpData.collapsed">
                <h5 align="left"> 
                <span>
                  <b-icon v-show="!dpData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="dpData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Drilling Parameters
              </h5>
              <!-- span>
                <b-icon v-show="dpData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!dpData.mandatory" icon="exclamation-circle" variant="danger" />
              </span -->
              </td>
            </tr>
            <tr :class="{ 'row-collapse': dpData.collapsed }">
              <td class="d-flex justify-content-between">
                <b-row>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avgWob" class="dx-field-label">Average WOB</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgWob" 
                          name="input-avgWob"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avgRop" class="dx-field-label">Average ROP</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgRop" 
                          name="input-avgRop"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avgRpm" class="dx-field-label">Average RPM/RPMM</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgRPM" 
                          name="input-avgRpm"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avgOBT" class="dx-field-label">Average On-Bottom Torque</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgOBTorque" 
                          name="input-avgOBT"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avg-flowrate" class="dx-field-label">Average Pump Flowrate</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgPumpFlowrate" 
                          name="input-avg-flowrate"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avg-standpipe" class="dx-field-label">Average Standpipe Pressure</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgStandpipePressure" 
                          name="input-avg-standpipe"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avg-scfm" class="dx-field-label">Average SCFM / Eqv. Flow Rate :</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgScfm" 
                          name="input-avg-scfm"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avg-air-drilling" class="dx-field-label">Average Air Drilling Pressure :</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgAirDrillingPressure" 
                          name="input-avg-air-drilling"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avg-foam" class="dx-field-label">Average Foam/Corr. Inhib. Rate :</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgFoam" 
                          name="input-avg-foam"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-last-sow" class="dx-field-label">Last SOW/ROTW/PUW :</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.lastSOW" 
                          name="input-avg-last-sow"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-avg-lossRate" class="dx-field-label">Average Loss Rate :</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.avgLossRate" 
                          name="input-avg-lossRate"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </td>
            </tr>
            <tr>
              <td class="d-flex pt-3 pb-1" @click="opData.collapsed = !opData.collapsed">
                <h5 align="left"> 
                <span>
                  <b-icon v-show="!opData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="opData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Operation Summary
              </h5>
              <span>
                <!-- b-icon v-show="opData.mandatory" icon="check-circle" variant="success" / -->
                <b-icon v-show="!opData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
              </td>
            </tr>
            <tr :class="{ 'row-collapse': opData.collapsed }">
              <td class="d-flex justify-content-between">
                <b-row>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-fuel-stock" class="dx-field-label">Current Fuel Stock</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.currentFuelStock" 
                          name="input-fuel-stock"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-fuel-consumption" class="dx-field-label">Daily Fuel Consumption</label>
                      <div class="dx-field-value full-width">
                        <DxNumberBox
                          v-model="form.dailyFuelConsumption" 
                          name="input-fuel-consumption"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-weather" class="dx-field-label">Weather</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.weather" 
                          name="input-weather"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-field-condition" class="dx-field-label">Field Condition</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.fieldCondition" 
                          name="input-field-condition"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <div class="dx-field">
                      <label for="input-status" class="dx-field-label">Status at xx am/pm</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.statusAtTime" 
                          name="input-status"
                          :disabled="!editable"
                          @change="opMandatoryCheck"
                        >
                          <DxValidator>
                            <DxRequiredRule :message="requiredMessage"/>
                          </DxValidator>
                        </DxTextBox>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12">
                    <div class="dx-field">
                      <label for="input-operation-summary" class="dx-field-label">24 Hour Operation Summary</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.summary24HOperation" 
                          name="input-operation-summary"
                          :max-length="255"
                          :disabled="!editable"
                          @change="opMandatoryCheck"
                        >
                          <DxValidator>
                            <DxRequiredRule :message="requiredMessage"/>
                          </DxValidator>
                        </DxTextBox>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12">
                    <div class="dx-field">
                      <label for="input-forecast" class="dx-field-label">24 Hour Forecast</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.forecast24H" 
                          name="input-forecast"
                          :max-length="255"
                          :disabled="!editable"
                          @change="opMandatoryCheck"
                        >
                          <DxValidator>
                            <DxRequiredRule :message="requiredMessage"/>
                          </DxValidator>
                        </DxTextBox>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12">
                    <div class="dx-field">
                      <label for="input-offline-activity" class="dx-field-label">Rig Offline Activity</label>
                      <div class="dx-field-value full-width">
                        <DxTextBox
                          v-model="form.rigOfflineActivity" 
                          name="input-offline-activity"
                          :max-length="255"
                          :disabled="!editable"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12">
                    <div class="dx-field">
                      <label for="input-general-comment" class="dx-field-label">General Comment</label>
                      <div class="dx-field-value full-width">
                        <DxTextArea
                          :value="form.generalComments"
                          :height="200"
                          :disabled="!editable"
                          />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </td>
            </tr>
          </table>
          <!-- div class="d-flex justify-content-between">
            <div class="d-flex" @click='picData.collapsed = !picData.collapsed'>
              <h5 align="left"> 
                <span>
                  <b-icon v-show="!picData.collapsed" scale="1" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="picData.collapsed" scale="1" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Personnel In Charge 
              </h5>
              <span>
                <b-icon v-show="picData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!picData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>  
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="picData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!picData.mandatory" icon="exclamation-circle" variant="danger" />
                  Mandatory data
              </span>
            </div>
          </div>
          <b-row v-show="!picData.collapsed" ref="pic"> 
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-supervisor">Supervisor(s)</label>
                <b-form-input
                  id="input-supervisor"
                  v-model="form.supervisors"
                  type="text"
                  placeholder="Enter supervisor name(s) with comma as delimiter"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-superintendent">Superintendent</label>
                <b-form-input
                  id="input-superintendent"
                  v-model="form.superintendent"
                  type="text"
                  placeholder="Enter superintendent name"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-tool-pusher">Tool Pusher</label>
                <b-form-input
                  id="input-tool-pusher"
                  v-model="form.toolPusher"
                  type="text"
                  placeholder="Enter Tool Pusher name"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-hse-supervisor">HSE Supervisor</label>
                <b-form-input
                  id="input-hse-supervisor"
                  v-model="form.hseSupervisor"
                  type="text"
                  placeholder="Enter HSE supervisor name"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-logistic-supervisor">Logistic Supervisor</label>
                <b-form-input
                  id="input-logistic-supervisor"
                  v-model="form.logisticSupervisor"
                  type="text"
                  placeholder="Enter logistic supervisor name"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-custom-role">Custom Role</label>
                <b-form-input
                  id="input-custom-role"
                  v-model="form.customRoles"
                  type="text"
                  placeholder="Enter custom role"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
            </b-row>
          <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='dcpData.collapsed = !dcpData.collapsed'>
              <h5 align="left">
                <span>
                  <b-icon v-show="!dcpData.collapsed" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="dcpData.collapsed" icon="chevron-bar-expand" class="hide-content" />
                </span>
                  Drilling and Cost Progress 
              </h5>
              <span>
                <b-icon v-show="dcpData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!dcpData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="dcpData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!dcpData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
              
            </div>
          </div>
          <b-row v-show="!dcpData.collapsed" ref="dcp">
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-previousDayMd">Previous Day MD</label>
                <b-form-input
                  id="input-previousDayMd"
                  v-model="previousDayMd"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-md">MD at 24:00</label>
                <b-form-input
                  id="input-md"
                  v-model="mdAt24"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-tvd">Est. TVD at 24:00</label>
                <b-form-input
                  id="input-tvd"
                  v-model="form.estTvd"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-progress">24Hr Progress</label>
                <b-form-input
                  id="input-progress"
                  v-model="progress24h"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-section">Section</label>
                <b-form-input
                  id="input-section"
                  v-model="section"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-rotatingHours">24Hr On-Bottom Hours</label>
                <b-form-input
                  id="input-rotatingHours"
                  v-model="form.obHours"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-percentComplete">Percent Activity Completed</label>
                <b-form-input
                  id="input-percentComplete"
                  v-model="form.percentActivityCompleted"
                  type="number"
                  placeholder="Enter Percent Complete"
                  required
                  @change="dcpMandatoryCheck"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-budget-plan">Budget Plan</label>
                <b-form-input
                  id="input-budget-plan"
                  v-model="budgetPlan"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-daily-field-cost">Daily Field Cost</label>
                <b-form-input
                  id="input-daily-field-cost"
                  v-model="dailyFieldCost"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-cumulative-cost">Cumulative Cost</label>
                <b-form-input
                  id="input-cummulative-cost"
                  v-model="cumulativeCost"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-remaining-budget">Remaining Budget</label>
                <b-form-input
                  id="input-remaining-budget"
                  v-model="remainingBudget"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-dfs">Days from Spud</label>
                <b-form-input
                  id="input-dfs"
                  v-model="dayFromSpud"
                  readonly
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-dol">Days on Location</label>
                <b-form-input
                  id="input-dol"
                  v-model="form.dayOnLocation"
                  type="number"
                  placeholder="Enter DOL"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-formation-type">Formation Type</label>
                <b-form-input
                  id="input-formation-type"
                  v-model="form.formationType"
                  type="text"
                  placeholder="Enter formation type"
                ></b-form-input>
              </b-col>
              <datalist id="size-list-id">
                <option v-for="(size, index) in casingSizes" :key="index">{{ size }}</option>
              </datalist>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-last-casing-size">Last Casing Size</label>
                <b-form-input
                  id="input-last-casing-size"
                  v-model="form.lastCasingSize"
                  type="text"
                  list="size-list-id"
                  placeholder="Enter recent casing size"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-last-casing-depth">Last Casing Depth</label>
                <b-form-input
                  id="input-last-casing-depth"
                  v-model="form.lastCasingDepth"
                  type="text"
                  placeholder="Enter recent casing depth"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-next-casing-size">Next Casing Size</label>
                <b-form-input
                  id="input-next-casing-size"
                  v-model="form.nextCasingSize"
                  type="text"
                  list="size-list-id"
                  placeholder="Enter next casing size"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-between pb-1">
                <label for="input-next-casing-depth">Next Casing Depth</label>
                <b-form-input
                  id="input-next-casing-depth"
                  v-model="form.nextCasingDepth"
                  type="text"
                  placeholder="Enter next casing depth"
                  :disabled="!editableOps"
                ></b-form-input>
              </b-col>
            </b-row>
          <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='dpData.collapsed = !dpData.collapsed'>
              <h5 align="left"> 
                <span>
                  <b-icon v-show="!dpData.collapsed" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="dpData.collapsed" icon="chevron-bar-expand" class="hide-content" />
                </span>  
                Drilling Parameters
              </h5>
              <span>
                <b-icon v-show="dpData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!dpData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="dpData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!dpData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
            </div>
          </div>
          <b-row v-show="!dpData.collapsed" class="fixHeightScrollable">
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-avg-wob">Average WOB:</label>
              <b-form-input
                id="input-avg-wob"
                v-model="form.avgWob"
                type="text"
                placeholder="Enter average WOB"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-avgRop">Average ROP:</label>
              <b-form-input
                id="input-avgRop"
                v-model="form.avgRop"
                type="text"
                placeholder="Enter Avg Rop"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-avg-rpm">Average RPM/RPMM</label>
              <b-form-input
                id="input-avg-rpm"
                v-model="form.avgRPM"
                type="text"
                placeholder="Enter average rpm"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-avg-obt">Average On-Botom Torque:</label>
              <b-form-input
                id="input-avg-obt"
                v-model="form.avgOBTorque"
                type="text"
                placeholder="Enter average on-bottom torque"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-average-pump-flowrate">Average Pump Flowrate:</label>
              <b-form-input
                id="input-average-pump-flowrate"
                v-model="form.avgPumpFlowrate"
                type="text"
                placeholder="Enter average pump flowrate"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-average-standpipe-pressure">Average Standpipe Pressure:</label>
              <b-form-input
                id="input-average-standpipe-pressure"
                v-model="form.avgStandpipePressure"
                type="text"
                placeholder="Enter average standpipe pressure"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-average-scfm">Average SCFM / Eqv. Flow Rate :</label>
              <b-form-input
                id="input-average-scfm"
                v-model="form.avgScfm"
                type="text"
                placeholder="Enter average scfm / equivalent flowrate"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-average-airdrilling-pressure">Average Air Drilling Pressure:</label>
              <b-form-input
                id="input-average-airdrilling-pressure"
                v-model="form.avgAirDrillingPressure"
                type="text"
                placeholder="Enter average air drilling pressure"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-average-foam">Average Foam / Corr. Inhib. Rate :</label>
              <b-form-input
                id="input-average-foam"
                v-model="form.avgFoam"
                type="text"
                placeholder="Enter average average foam / corr. inhib. rate"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-last-sow-rotw-puw">Last SOW/ROTW/PUW:</label>
              <b-form-input
                id="input-last-sow-rotw-puw"
                v-model="form.lastSOW"
                type="text"
                placeholder="Enter last SOW/ROTW/PUW"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-average-loss-rate">Average Loss Rate:</label>
              <b-form-input
                id="input-average-loss-rate"
                v-model="form.avgLossRate"
                type="text"
                placeholder="Enter average loss rate"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
          </b-row>
          <hr />
          <div class="d-flex justify-content-between">
            <div class="d-flex" @click='opData.collapsed = !opData.collapsed'>
              <h5 align="left"> 
                <span>
                  <b-icon v-show="!opData.collapsed" icon="chevron-bar-contract" class="show-content" />
                  <b-icon v-show="opData.collapsed" icon="chevron-bar-expand" class="hide-content" />
                </span>
                Operation Summary 
              </h5>
              <span>
                <b-icon v-show="opData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!opData.mandatory" icon="exclamation-circle" variant="danger" />
              </span>
            </div>
            <div v-show="false">
              <span class="border border-primary p-1">
                <b-icon v-show="opData.mandatory" icon="check-circle" variant="success" />
                <b-icon v-show="!opData.mandatory" icon="exclamation-circle" variant="danger" />
                Mandatory data
              </span>
            </div>
          </div>
          <b-row v-show="!opData.collapsed" class="fixHeightScrollable">
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-current-fuel-stock">Current Fuel Stock:</label>
              <b-form-input
                id="input-current-fuel-stock"
                v-model="form.currentFuelStock"
                type="number"
                step="0.001"
                placeholder="Enter current fuel stock"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-daily-fuel-consumption">Daily Fuel Consumption:</label>
              <b-form-input
                id="input-daily-fuel-consumption"
                v-model="form.dailyFuelConsumption"
                type="number"
                step="0.001"
                placeholder="Enter daily fuel consumption"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-weather">Weather:</label>
              <b-form-input
                id="input-weather"
                v-model="form.weather"
                type="text"
                placeholder="Enter Weather"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-tree-condition">Field Condition</label>
              <b-form-input
                id="input-treeCondition"
                v-model="form.fieldCondition"
                type="text"
                placeholder="Enter Tree Condition"
                :disabled="!editableOps"
              ></b-form-input>
            </b-col>
            <b-col cols="6" class="d-flex justify-content-between pb-1">
              <label for="input-current-status">Status at xx am/pm :</label>
              <b-form-input
                id="input-currentStatus"
                v-model="form.statusAtTime"
                type="text"
                placeholder="Enter status at last hours in operation summary report"
                :disabled="!editableOps"
                required
                @change="opMandatoryCheck"
              ></b-form-input>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-between pb-1">
              <label for="input-24HrOperationsSummary">24 Hr Operations Summary:</label>
              <b-form-textarea
                id="input-24HrOperationsSummary"
                v-model="form.summary24HOperation"
                type="text"
                placeholder="Enter 24 Hr Operations Summary"
                :disabled="!editableOps"
                required
                @change="opMandatoryCheck"
              ></b-form-textarea>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-between pb-1">
              <label for="input-24HrForecast">24 Hr Forecast:</label>
              <b-form-textarea
                id="input-24HrForecast"
                v-model="form.forecast24H"
                type="text"
                placeholder="Enter 24 Hr Forecast"
                :disabled="!editableOps"
                required
                @change="opMandatoryCheck"
              ></b-form-textarea>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-between pb-1">
              <label for="input-rig-offline-activity">Rig Offline Activity:</label>
              <b-form-textarea
                id="input-rig-offline-activity"
                v-model="form.rigOfflineActivity"
                type="text"
                placeholder="Enter rig offline activity"
                :disabled="!editableOps"
              ></b-form-textarea>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-between pb-1">
              <label for="input-comments">General Comments:</label>
              <b-form-textarea
                id="input-comments"
                v-model="form.generalComments"
                type="text"
                placeholder="Enter Comments"
                :disabled="!editableOps"
              ></b-form-textarea>
            </b-col>
          </b-row -->
        </div>
        <hr />
      </b-form>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formMethods, formComputed, authComputed } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons, BIconUpload } from 'bootstrap-vue'
import axios from 'axios'
import qs from 'querystring'
import mapApiUrl from '@/src/utils/api-mapper'
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
} from 'devextreme-vue/form'
import DxTextArea from 'devextreme-vue/text-area'
import DxTextBox from 'devextreme-vue/text-box'
import {
  DxValidator,
  DxRequiredRule,
} from 'devextreme-vue/validator'
import { DxNumberBox } from 'devextreme-vue/number-box'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import DxSelectBox from 'devextreme-vue/select-box'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component('BIconUpload', BIconUpload)
Vue.use(VueFormGenerator)

export default {
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxButton,
    DxTextBox,
    DxTextArea,
    DxNumberBox,
    DxValidator,
    DxRequiredRule,
    DxSelectBox
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    dailyReportDate: {
        type: String,
    },
    lastSubmitId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      form: {},
      optionsComboHoleSize: [],
      hasData: false,
      editableOps: this.editable,
      files: [],
      showOptionContigency: false,
      fileNameUpload: '',
      fileUpload: '',
      loadingOn: false,
      opsumData: [{},{}],
      mdAt24: 0,
      previousDayMd: 0,
      progress24h: 0,
      wellCost: 0,
      currentCost: 0,
      standingBudget: 0,
      wellBudget: 0,
      requiredMessage: 'This value is required',
      section: '',
      comboOptionPhasecode: [],
      casingSizes: ['4 1/2', '5', '5 1/2', '6 5/8', '7', '7 5/8', '7 3/4', '7 7/8', '8 5/8', '9 5/8', '9 7/8', '10 3/4', '11 3/4', '11 7/8', '12 1/4', '13 3/8', '13 1/2', '13 5/8', '14', '14 3/4', '16', '17 1/2', '18 5/8', '20', '22', '24', '26', '30', '32', '36', '40', '42'],
      picData: {collapsed: true, mandatory: true, visibility: 'collapse'},
      dcpData: {collapsed: true, mandatory: false, requiredFields: ['percentActivityCompleted','dayOnLocation']},
      dpData: {collapsed: true, mandatory: true},
      opData: {collapsed: true, mandatory: false, requiredFields: ['statusAtTime','summary24HOperation','forecast24H']},
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    dailyFieldCost() {
      return this.currencyFormatter(this.currentCost)
    },
    cumulativeCost() {
      return this.currencyFormatter(this.wellCost)
    },
    remainingBudget() {
      return this.currencyFormatter(this.wellBudget - this.wellCost)
    },
    budgetPlan() {
      return this.currencyFormatter(this.wellBudget)
    },
    dayFromSpud() {
      // console.log('Report Date: '+this.dailyReportDate+', spud date: '+this.currentWell.spudDate)
      const dfs = (new Date(this.dailyReportDate) - Date.parse(this.currentWell.spudDate)) / (24*3600000)
      return dfs >= 0 ? dfs : 0
    }
  },
  watch: {
    submitId: function (value) {
      this.init()
    },
    editable: function (val) {
      this.editableOps = val
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    init() {
      this.form = {}
      this.getCurrentCost()
      this.getCostCumulative()
      this.getWellBudget()
      this.getOpsumData()
      this.loadCombo()
      this.refreshForm()
    },
    currencyFormatter(value) {
      let numericValue = parseFloat(value)
      return '$' + numericValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    getCostCumulative() {
      this.costData = []
      const url = mapApiUrl('/api/form/master/cost/get-cum-well-cost-to-date')
      let params={wellId: this.wellId, refDate: this.dailyReportDate.substring(0,10)}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
          this.wellCost = response.data
      })
    },
    getWellBudget() {
      axios.get(mapApiUrl("/api/form/master/general/get-well-budget"),
        {params: {wellId: this.wellId}})
        .then((response) => {
          if (response.data) {
            this.wellBudget = response.data
          }
        })

    },
    getCurrentCost() {
      const url = mapApiUrl('/api/form/master/cost/list-views')
      let params={submitId: this.submitId}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        if (response.data && response.data.length>0) {
          let sum = 0
          for (const costEntry of response.data) {
            sum += costEntry.qty * costEntry.costPerUnit
          }
          this.currentCost = sum
        }
      })
    },
    getOpsumData() {
      this.opsumData = []
      axios(mapApiUrl("/api/form/master/operation-summary/list"),
      {params: {submitId: this.submitId}})
      .then((response) => {
        if (response.data === undefined || response.data.length === 0) return
        this.opsumData = response.data
        let hoursCount = 0
        this.opsumData.sort((a,b) => a.id - b.id)
        for (const data of this.opsumData) {
          if (Math.ceil(hoursCount + data.hours) === 24) {
            this.mdAt24 = data.endMd
          }
          hoursCount += data.hours
          this.previousDayMd = data.endMd
        }
        this.section = this.opsumData.at(-1).phaseCode
        if (this.opsumData.length > 2) {
          this.progress24h = this.opsumData[this.opsumData.length-1].endMd - this.opsumData[0].endMd
        } else this.progress24h = 0
      })
    },
    refreshForm() {
      const url = mapApiUrl('/api/form/master/general/get')
      let params={submitId: this.submitId}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        if (response.data) {
          this.form = {...response.data}
          this.dcpMandatoryCheck()
          this.opMandatoryCheck()
        }
      })
    },
    getCarryOver() {
      const url = mapApiUrl('/api/form/master/general/get')
      let params={submitId: this.lastSubmitId}
      axios
      .get(url, {
        params: params
      })
      .then((response) => {
        if (response.data) {
          this.form.supervisors = response.data.supervisors
          this.form.superintendent = response.data.superintendent
          this.form.toolPusher = response.data.toolPusher
          this.form.hseSupervisor = response.data.hseSupervisor
          this.form.logisticSupervisor = response.data.logisticSupervisor
          this.form.customRoles = response.data.customRoles
          this.form.formationType = response.data.formationType
          this.form.lastCasingSize = response.data.lastCasingSize
          this.form.lastCasingDepth = response.data.lastCasingDepth
          this.form.nextCasingSize = response.data.nextCasingSize
          this.form.nextCasingDepth = response.data.nextCasingDepth
        }
      })
    },
    convertNomSize(nom) {
      if (!isNaN(nom)) return nom
      let sizeStrings = nom.split(" ")
      let sizeValue = parseFloat(sizeStrings[0])
      if (sizeStrings.length > 1) {
        let element = sizeStrings[1].split("/")
        let elementsValue = parseFloat(element[0]) / parseFloat(element[1])
        sizeValue += elementsValue
      }
      return sizeValue
    },
    dcpMandatoryCheck() {
      this.dcpData.mandatory = !isNaN(parseFloat(this.form.percentActivityCompleted))
    },
    opMandatoryCheck() {
      this.opData.mandatory = this.form.statusAtTime !== undefined && this.form.statusAtTime !== null
          && this.form.summary24HOperation !== undefined && this.form.summary24HOperation !== null
          && this.form.forecast24H !== undefined && this.form.forecast24H !== null
    },
    validityCheck() {
      if (!this._isMounted) return
      for (const element of this.$children) {
        if (element.$vnode.componentOptions.tag === 'b-form-input') {
        }
      }
    },
    loadCombo() {
      this.getComboListWorkstringSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        _arrData.sort((x,y)=>this.convertNomSize(x.comboValue)-this.convertNomSize(y.comboValue))
        this.optionsComboHoleSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboHoleSize.push(_temp)
        }
      })
      this.getComboOptionPhasecode({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.comboOptionPhasecode = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.comboOptionPhasecode.push(_temp)
        }
      })

    },
    onSubmit(evt) {
      evt.preventDefault()
      let rowData = this.form
      rowData.submitId = this.submitId
      rowData.dailyReportId = this.submitId
      const url = mapApiUrl('/api/form/master/general/add')
      axios.post(url, qs.stringify(rowData)).then((response) => {
        this.refreshForm()
        notify({ message: 'General data has been recorded.', width: 500 }, 'success', 3000)
      })
    },
    onReset(evt) {

    }
  },
}
</script>